// components/VisitTable.jsx
import React from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

const VisitTable = ({ title, data }) => {
  return (
    <div className="my-4">
      <h5 className="text-center">{title}</h5>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Date</th>
            <th>Visit Count</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={index}>
                <td>{new Date(item.date).toLocaleDateString()}</td>
                <td>{item.count}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="2" className="text-center">No visits</td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

VisitTable.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
};

export default VisitTable;
